// removed by extract-text-webpack-plugin
module.exports = {"no-permission-container":"no-permission-container","locale-EN":"locale-EN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/NoPermission/NoPermission.scss
// module id = /gsv
// module chunks = 0